export const ConstructorSchemesStoresCreatePluginSettings: IPluginSettings = {
    name: 'склады',
    mnemocode: 'constructor_schemes_create_plugin',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 100
        },
        {
            order: 1,
            propertyName: 'displayName',
            propertyType: 'string',
            displayName: 'Наименование',
            visibility: true,
            width: 550
        },
    ],
}
